import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { getBlog } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { getBlog().then(setPosts).catch(() => setPosts([])); }, []);

  return (
    <div data-testid="blog-page">
      <section className="bg-navy grain relative pt-[120px] pb-16 lg:pt-[150px] lg:pb-20">
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8">
          <p className="eyebrow text-gold mb-4 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-gold" /> Insights & Education
          </p>
          <h1 className="font-heading font-extrabold tracking-tighter text-warm-white text-[clamp(2.6rem,6vw,4.6rem)] leading-[0.98]">
            The WF Services blog.
          </h1>
          <p className="mt-5 text-light-slate text-lg max-w-xl">
            Straight answers to the real questions clients ask about Life &amp; Health coverage.
          </p>
        </div>
      </section>

      <section className="bg-warm-white py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {posts.map((p, i) => (
              <motion.div key={p.slug}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`}
                  className="group flex flex-col h-full rounded-2xl border border-black/[0.08] bg-white p-7 transition-all hover:border-navy/30 hover:-translate-y-1">
                  <p className="eyebrow text-gold mb-3">{p.category}</p>
                  <h2 className="font-heading font-bold text-navy text-xl leading-snug">{p.title}</h2>
                  <p className="mt-3 text-brand-slate text-sm leading-relaxed flex-1">{p.excerpt}</p>
                  <span className="mt-6 flex items-center justify-between text-xs text-light-slate">
                    {p.read_time}
                    <ArrowUpRight weight="bold" size={16} className="text-navy transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
